import React, { useEffect, useState } from "react";
import { renderElement } from "../../components/common/FormRendererV2/Renderer";
import { Button, Col, Form, Row } from "react-bootstrap";
import "./index.scss";
import { useDispatch, useSelector } from "react-redux";
import {
  setSelectValidError,
  updateRendererFormState,
} from "../../store/slices/commonSlice";
import { useLocation, useNavigate } from "react-router-dom";
import { buyNow, home, paymentSummary } from "../../utils/router/constant";
import {
  getFormRenderer,
  updateFromRenderer,
} from "../../service/profile/profileService";
import NavLayout from "../../layout/navLayout";
import { getCustomerInfo } from "../../service/proposal/proposalService";
import {
  getParamsFromURL,
  setParamsInURL,
  useIsMobile,
  getCodeFromUrl,
} from "../../utils/helper";
import { AG_CODE } from "../../utils/commonConstant";
import { EditIcon } from "../../assets/images/svg/svg";
import StepFormTabs from "../../components/common/stepFormTabs";

function ProfilePage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [index, setIndex] = useState(0);
  const [orderId, setOrderId] = useState(null);
  const [entityid, setEntityId] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const entityId = useSelector((state) => state.common.entityId);
  const formState = useSelector((state) => state.common.formRendererState);
  const customerData = useSelector((state) => state.common.customerData);
  const agDetails = useSelector((state) => state.common.agDetails);
  const ProfileFieldsJSON = useSelector(
    (state) => state.profile?.ProfileFieldsJSON
  );
  const ProfileLayoutJSON = useSelector(
    (state) => state.profile?.ProfileLayoutJSON || []
  );
  const organizationId = customerData?.organizationid;
  const isMobile = useIsMobile();

  useEffect(() => {
    const fetchCode = async () => {
      await getParamsFromURL(location).then((params) => {
        if (params) {
          setOrderId(params["orderId"]);
          setEntityId(params["entityid"]);
        } else {
          console.error("No parameters found");
        }
      });
    };
    fetchCode();
  }, [location]);
  useEffect(() => {
    if (customerData.parentid && organizationId) {
      getFormRenderer(customerData.parentid, organizationId);
    }
  }, [customerData.parentid, organizationId]);

  const handlePrevious = () => {
    if (index > 0) {
      setIndex(index - 1);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const action = e.nativeEvent.submitter.getAttribute("data-action");

    if (formState) {
      dispatch(setSelectValidError(false));

      if (action === "next" && index < ProfileLayoutJSON.length - 1) {
        setIndex(index + 1);
      } else if (action === "finish") {
        try {
          const success = await updateFromRenderer(formState, entityId, "AGM");

          if (success) {
            await getCustomerInfo();
            if (entityid && orderId) {
              const paramObject = {
                entityid: entityid,
                orderId: orderId,
              };
              const params = await setParamsInURL(location, paramObject);
              const agCode = getCodeFromUrl();
              // profile_enabled false (MSCDA): proposal form is still filled before payment
              if (
                (agCode === AG_CODE || agCode === "chem") &&
                agDetails?.profile_enabled !== false
              ) {
                navigate(`${paymentSummary}?${params}`);
              } else {
                navigate(`${buyNow}?${params}`);
              }
            } else {
              navigate(home);
            }
          } else {
            console.error("Something went wrong");
          }
        } catch (error) {
          console.error("Error processing entity", error);
        }
      }
    } else {
      dispatch(setSelectValidError(true));
    }
  };
  const renderProfileJson = () => {
    if (!customerData?.profile_json) return <p>No profile data available</p>;

    const parsedProfile = JSON.parse(customerData.profile_json);

    const fieldsLookup = Object.values(ProfileFieldsJSON).reduce(
      (acc, field) => {
        acc[field["database-label"]] = field;
        return acc;
      },
      {}
    );

    const formatDate = (value) => {
      const date = new Date(value);
      if (!isNaN(date.getTime())) {
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
      }
      return value;
    };

    const formatYear = (value) => {
      if (typeof value === "string") {
        const match = value.match(/(\d{4})$/);
        if (match) return match[1];
      }
      const date = new Date(value);
      if (!isNaN(date.getTime())) {
        return date.getFullYear();
      }
      return value;
    };

    const renderChildFields = (childData) => {
      const fields = [];

      childData?.forEach((child, index) => {
        if (
          child.elementtype === "select" ||
          child.elementtype === "textfield" ||
          child.elementtype === "email" ||
          child.elementtype === "date" ||
          child.elementtype === "number" ||
          child.elementtype === "textarea" ||
          child.elementtype === "year"
        ) {
          const labelKey = `${child.elementid}-${child.elementtype}`;
          const fieldLabel =
            ProfileFieldsJSON[labelKey]?.["display-fieldlabel"] ||
            child.elementid;
          const databaseLabel = ProfileFieldsJSON[labelKey]?.["database-label"];
          const fieldValue = parsedProfile[databaseLabel];
          const formattedValue =
            databaseLabel === "ag_name"
              ? customerData?.ag_name || "-"
              : child.elementtype === "year" && fieldValue
                ? fieldValue.match(/(\d{4})$/)?.[1] || fieldValue
                : fieldValue &&
                  typeof fieldValue === "string" &&
                  fieldValue.match(/^\d{4}-\d{2}-\d{2}/)
                  ? formatDate(fieldValue)
                  : fieldValue;

          fields.push(
            <Col span={12} className="profile-field" key={child.elementid}>
              <div className="profile-label">{fieldLabel} :</div>
              <div className="profile-value">{formattedValue || "-"}</div>
            </Col>
          );
        }

        if (child.child) {
          fields.push(renderChildFields(child.child));
        }
      });

      return fields;
    };

    return (
      <div className="profile-json-view">
        {ProfileLayoutJSON.map((element, ind) => (
          <fieldset className="form-fieldset" key={element.elementid}>
            <legend className="">{element.name || `Section ${ind + 1}`}</legend>
            <Row className="profile-row">
              {element.child && renderChildFields(element.child)}
            </Row>
          </fieldset>
        ))}
      </div>
    );
  };

  const handleEditClick = () => {
    if (!isEditing) {
      const parsedProfile = JSON.parse(customerData.profile_json);
      dispatch(updateRendererFormState(parsedProfile));
    }
    setIsEditing(!isEditing);
  };

  return (
    <NavLayout>
      <div className="profile-header">
        <div className="profile-head">Profile</div>
        {customerData?.is_first_login === 0 && (
          <Button
            className={`btn-edit ${isEditing ? "btn-outline" : ""}`}
            onClick={handleEditClick}
          >
            {!isEditing && <EditIcon className="editIcon" />}{" "}
            {/* Show EditIcon only if not editing */}
            {isEditing ? "CANCEL" : "EDIT"}
          </Button>
        )}
      </div>
      <div>
        {isEditing ||
          !customerData?.is_first_login === 0 ||
          customerData?.is_first_login === 1 ? (
          <div className="profile-container">
            <Form onSubmit={handleSubmit}>
              <div>
                {isMobile ? (
                  <div className="mobile-step-tabs">
                    <StepFormTabs
                      steps={ProfileLayoutJSON}
                      currentStep={index}
                      direction="horizontal"
                    />
                  </div>
                ) : (
                  <div className="tab-wrapper">
                    {ProfileLayoutJSON.map((element, ind) => (
                      <div
                        key={element.elementid}
                        className={`profile-active ${index === ind ? "active-tab" : "inactive-tab"
                          }`}
                        style={{
                          pointerEvents: ind <= index ? "auto" : "none",
                          opacity: ind <= index ? 1 : 0.5,
                        }}
                      >
                        {/* <div className="step-container">
                      <div>
                        <span
                          className={`step-indicator ${
                            index >= ind ? "active-step-indicator" : ""
                          }`}
                        >
                          {ind + 1}
                        </span>
                        {ind < ProfileLayoutJSON.length - 1 && (
                          <div
                            className={`step-line ${
                              index < index ? "active-step-line" : ""
                            }`}
                          ></div>
                        )}
                      </div>
                    </div> */}
                        {renderElement(
                          element,
                          ProfileFieldsJSON,
                          formState,
                          () => setIndex(ind),
                          index,
                          ind
                        )}
                      </div>
                    ))}
                  </div>
                )}

                <div className="form-content">
                  {ProfileLayoutJSON[index]?.child?.length > 0 ? (
                    ProfileLayoutJSON[index]?.child.map((it) =>
                      renderElement(it, ProfileFieldsJSON, formState)
                    )
                  ) : (
                    <p>No fields to display</p>
                  )}
                </div>
              </div>
              <Row>
                <div className="navigation-buttons">
                  <Col md={2}></Col>
                  <Col md={10} className="button-wrapper">
                    <Button
                      variant="primary previous"
                      onClick={handlePrevious}
                      disabled={index === 0}
                    >
                      Previous
                    </Button>
                    {index === ProfileLayoutJSON.length - 1 ? (
                      <Button
                        variant="primary next"
                        type="submit"
                        color="success"
                        data-action="finish"
                      >
                        Finish
                      </Button>
                    ) : (
                      <Button
                        variant="primary next"
                        type="submit"
                        color="primary"
                        data-action="next"
                      >
                        Next
                      </Button>
                    )}
                  </Col>
                </div>
              </Row>
            </Form>
          </div>
        ) : (
          renderProfileJson()
        )}
      </div>
    </NavLayout>
  );
}

export default ProfilePage;
